import { get, post } from './shared';

const apiHost =
  process.env.NODE_ENV === 'production'
    ? process.env.GATSBY_MARKETTAP_PLATFORM_API_HOST
    : '';

export const createCart = async () => {
  const endpoint = `${apiHost}/api/v1/guest_carts`;
  const json = await post(endpoint);
  return json;
};

export const fetchCart = async id => {
  const endpoint = `${apiHost}/api/v1/guest_carts/${id}`;
  const json = await get(endpoint);
  return json;
};

export const update = async (id, cart) => {
  const cartParams = {
    guestCart: {
      cartItemsAttributes: [cart],
    },
  };
  const endpoint = `${apiHost}/api/v1/guest_carts/${id}`;
  const json = await post(endpoint, cartParams, 'PATCH');
  return json;
};

export const addCartItem = async (id, cartItem) => {
  const cartParams = {
    cartItem,
  };
  const endpoint = `${apiHost}/api/v1/guest_carts/${id}/add_item`;
  const json = await post(endpoint, cartParams, 'POST');
  return json;
};

export const updateCartItem = async (id, cartItem) => {
  const cartParams = {
    cartItem,
  };
  const endpoint = `${apiHost}/api/v1/guest_carts/${id}/update_item`;
  const json = await post(endpoint, cartParams, 'POST');
  return json;
};

export const deleteCartItem = async (id, itemId) => {
  const json = await update(id, { id: itemId, _destroy: true });
  return json;
};



// WEBPACK FOOTER //
// ./src/api/cart.js